import { PaginationInfo } from "./loan.model";

export interface GetWalletInfoResponse {
  balanceAmount: number;
  lastCashoutDate: Date;
  lastCashoutDate_Persian: string;
  minimumDailyWithdrawalAmount: number;
  maximumDailyWithdrawalAmount: number;
}
export interface CreateNewPaymentRequest {
  description: string;
  loanRefKeys: string[];
}

export interface GetLoansReadyForSettlementResponse {
  referenceKey: string;
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  loanTemplateTitle: string;
  loanAmount: number;
  settlementAmount: number;
  assignedDate: Date;
  assignedDate_Persian: string;
  financialSupplierTitle: string;
  supplierUser: string;
  supplierUserMobile: string;
}

export class GetPaymentHistoryRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}

export class Filter {
  fromDate: string | undefined;
  toDate: string | undefined;
}

export interface GetPaymentHistoryResponse {
  key: string;
  requestDate: Date;
  requestDate_Persian: string;
  settlementDate: Date;
  settlementDate_Persian: string;
  settlementAmount: number;
  description: string;
  supplierUser: string;
  supplireIban: string;
  paymentHistoryItems: PaymentHistoryItems[] | any;
  supplierId: number;
  supplierUserId: number;
  status: string;
}
export interface PaymentHistoryItems {
  referenceKey: string;
  customerName: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  loanTemplateTitle: string;
  loanAmount: number;
  settlementAmount: number;
  assignedDate: Date;
  assignedDate_Persian: string;
  financialSupplierTitle: string;
  supplierUser: string;
  supplierUserMobile: string;
}
export class GetPaymentRequestInfoResponse {
  key: string | undefined;
  supplierId: number | undefined;
  supplierTitle: string | undefined;
  supplierLogo: string | undefined;
  supplierUserTitle: string | undefined;
  requestPersianDate: string | undefined;
  settlementAmount: number | undefined;
  supplierIban: string | undefined;
  description: string | undefined;
  loanRequests?: LoanRequests[] | undefined | any;
}

export class LoanRequests {
  referenceKey: string | undefined;
  customerTitle: string | undefined;
  customerMobile: string | undefined;
  loanTemplateTitle: string | undefined;
  loanAmount: number | undefined;
  settlementAmount: number | undefined;
  loanAssignPersianDate: string | undefined;
  financialSupplierTitle: string | undefined;
  supplierUserTitle: string | undefined;
  supplierUserMobile: string | undefined;
}
export class PaymentSettlementKeyRequest {
  paymentSettlementKey: string | undefined;
}
